// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbx_a big_i big_j","ColorVariants__color":"bbx_b big_rp","ColorVariants__more":"bbx_c big_vv"};